/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataService } from '../../services/data.service';
import { UtilsService } from '../../services/utils.service';
import { DataFormatterService } from 'src/app/common/data-formatter.service';
import { EllipsisDirective } from 'ngx-ellipsis';

@Component({
  selector: 'app-chat-menu',
  templateUrl: './chat-menu.component.html',
  styleUrls: ['./chat-menu.component.scss'],

})
export class ChatMenuComponent implements OnInit {



  @Output() addConversation: EventEmitter<{ newConversation: boolean, oldMessages?: any,newMessages?:any }> = new EventEmitter();

  constructor(private dataService: DataService, public utilService: UtilsService, private cdr: ChangeDetectorRef, private dfs: DataFormatterService,) { }

  messages: any[] = [];
  updatedSnaps: any = [];

  seeMore: boolean = false;
  seeMoreSnaps: boolean = false;
 

  deleteConfirm: boolean = false;
  deleteAllConfirm:boolean=false
  startIndex=5
  endIndex=200

  snaps: any[] = ['Nov 12,2024', 'Nov 12,2024', 'Nov 12,2024', 'Nov 12,2024', 'Nov 12,2024', 'Nov 12,2024', 'Nov 12,2024', 'Nov 12,2024']
  selectedSchema: string = 'Default';

  schemaList: string[] = ['Default'];
  alertButtons = [{
    text: 'Cancel', cssClass: 'alert-button-cancel', handler: () => {
      this.deleteConfirm = false;

    },
  }, {
    text: 'Yes, Delete', cssClass: 'alert-button-confirm', handler: () => {
      this.deleteConfirm = true;

    }
  }];
  alertAllButtons = [{
    text: 'Cancel', cssClass: 'alert-button-cancel', handler: () => {
      this.deleteAllConfirm = false;

    },
  }, {
    text: 'Yes, Delete all', cssClass: 'alert-button-confirm', handler: () => {
      this.deleteAllConfirm = true;

    }
  }];

  ngOnInit() {
    this.getConversation();
    this.updatedSnaps = this.seeMoreSnaps ? this.snaps.slice(0) : this.snaps.slice(0, 5);
   

  }


  newChat() {
    this.addConversation.emit({ newConversation: true });
    this.utilService.conversationTitle = 'New Chat'
    this.utilService.selectedIndex = -1;
    this.utilService.promptMenuOpen=false;
    this.utilService.filterMenuOpen=false;
    this.utilService.qid=0
    this.utilService.cid=0
    if (this.utilService.isNewConversations) {

      this.getConversation();
     
    }
    
    
  }
  getConversation() {
   
    this.utilService.isNewConversations = false;
    this.dataService.getAllConversations().subscribe((res) => {
      this.utilService.Conversations = this.dfs.sortResultsByNumber(res.data);

      this.utilService.lessConversation = this.utilService.Conversations.length > 5 ? true : false
      this.utilService.deleteAllEnabled=this.utilService.Conversations.length > 1 ? true : false
      this.utilService.updatedConversations = this.seeMore ? this.utilService.Conversations.slice(0) : this.utilService.Conversations.slice(0, 5);

    },
      (err) => {
        console.log(err);
      })
  }
  getMessages(id: string, index: number, topic: string) {
    this.utilService.closeMenu()
    if (this.utilService.selectedIndex != index) {
      this.utilService.promptMenuOpen=false;
      this.utilService.filterMenuOpen=false
      if (topic === 'New Chat....') {
        id = this.utilService.newConversationId!;
      }
      this.utilService.qid=0
      this.utilService.cid=id
      this.utilService.selectedIndex = index;
      this.utilService.conversationTitle = topic;
      this.utilService.dataLoaded = false;
      this.utilService.isOldConversations = true;
      this.cdr.detectChanges();
   
      this.dataService.getAllMessages(id).subscribe(
        (res) => {
          this.messages = res?.data || [];  
          this.utilService.setConversationId(id);
          if(this.utilService.getConversationMessages(id)
              ){
            if(this.messages.length==this.utilService.getConversationMessages(id).length){
                      this.messages=this.utilService.getConversationMessages(id)
            }
            else{
              this.messages=this.utilService.getConversationMessages(id).concat(this.messages.slice(this.utilService.getConversationMessages(id).length));
              this.utilService.oldConversations=this.messages;
              this.utilService.addConversationMessages();
            }
          }
          else{
            this.messages=res?.data || [];  
            this.utilService.oldConversations=this.messages;
            this.utilService.addConversationMessages();
          }
          this.utilService.dataLoaded = true;
          this.cdr.detectChanges();
          this.utilService.preventAutoScroll();
          this.addConversation.emit({ newConversation: false, oldMessages: this.messages });
        },
        (err) => {
          console.log(err);
          this.utilService.dataLoaded = true;
          this.cdr.detectChanges();
          this.addConversation.emit({ newConversation: false, oldMessages: this.messages });
          this.utilService.setConversationId(id);
        }
      );
 
  }
    
  }
  deleteConversation(deleteConfirm: boolean, topic: string, conversationId?: string, index?: any,) {
    this.utilService.deleteConfirmationAlert = false;
    if (topic === 'New Chat....') {
      conversationId = this.utilService.newConversationId!;
    }
    if (deleteConfirm) {
      this.dataService.deleteConverastion(conversationId!).subscribe((res) => {

        this.utilService.Conversations = this.utilService.Conversations.filter(
          (conversation: { conversation_id: string; }) => conversation?.conversation_id !== conversationId
        );

        this.utilService.lessConversation = this.utilService.Conversations.length > 5 ? true : false
        this.utilService.deleteAllEnabled=this.utilService.Conversations.length > 1 ? true : false
        this.utilService.updatedConversations = this.seeMore ? this.utilService.Conversations.slice(0) : this.utilService.Conversations.slice(0, 5);

        if (index === this.utilService.selectedIndex) {
          this.newChat();
        }
        else if (index < this.utilService.selectedIndex) {
          this.utilService.selectedIndex = this.utilService.selectedIndex - 1
        }
      },
        (err) => {
          console.log(err)
        })

    }
    else {
      this.utilService.deleteConfirmationAlert = false;
    }
  }
  clickSeeMore(data: string) {

    if (data == 'conversation') {
      if(!this.seeMore){
            if(this.utilService.Conversations.length>=200){
              this.utilService.updatedConversations=this.utilService.updatedConversations.concat(this.utilService.Conversations.slice(this.startIndex,this.endIndex))
              this.startIndex=this.endIndex
              this.endIndex=this.startIndex+200
            }
            else{
              this.utilService.updatedConversations=this.utilService.Conversations
              this.seeMore=false
            }
            if(
              this.utilService.updatedConversations.length===this.utilService.Conversations.length){
                this.seeMore = !this.seeMore;
              }
            
      }
      else{
        this.utilService.updatedConversations=this.utilService.Conversations.slice(0, 5);
        this.seeMore = !this.seeMore;
        this.startIndex=5
        this.endIndex=200
      }
      // this.utilService.updatedConversations = !this.seeMore ? this.utilService.Conversations.slice(0,200) : this.utilService.Conversations.slice(0, 5);
      // this.seeMore = !this.seeMore;

    }
    else if (data == 'snaps') {
      this.updatedSnaps = !this.seeMoreSnaps ? this.snaps.slice(0) : this.snaps.slice(0, 5);

      this.seeMoreSnaps = !this.seeMoreSnaps;
    }
  }
  deleteAllconversations(deleteAllConfirm: boolean) {
    this.utilService.deleteAllConfirmationAlert = false;

    if (deleteAllConfirm) {
      this.dataService.deleteAllConversations().subscribe((res) => {
        // Update the flag only after successful deletion
        this.utilService.deleteAllEnabled = false;

        // Clear the conversations and other state
        this.utilService.updatedConversations = [];
        this.utilService.Conversations = [];
        this.utilService.lessConversation = this.utilService.Conversations.length > 5 ? true : false // Reset the less conversation state

        // Detect changes manually after the update
        this.cdr.detectChanges();
        this.newChat();
      }, (err) => {
        console.error('Error deleting all conversations:', err);
      });
    } else {
      this.utilService.deleteAllConfirmationAlert = false;
    }
}
  selectSchema(schema: string) {
    this.selectedSchema = schema;
  }
  setOpen(isOpen: boolean) {

    this.utilService.deleteConfirmationAlert = true;
    this.cdr.detectChanges();

  }
  setOpenDelete(isOpen: boolean) {

    this.utilService.deleteAllConfirmationAlert = true;
    this.cdr.detectChanges();

  }

  async downloadTableToCSV(id: string,index:any,topic:string) {

    let csvContent = ""
    let conversations=[]
    try {
      if(index!==this.utilService.selectedIndex||topic === 'New Chat....'){
        if (topic === 'New Chat....') {
          id = this.utilService.newConversationId!;
        }
      const res = await this.dataService.getAllMessages(id).toPromise();  
       conversations = res?.data || [];
      }
      else{
        conversations= this.messages;
      }
     
      conversations.forEach((entry: { role: string; content: string | any[]; }) => {
        if (entry.role === 'user') {
          csvContent = csvContent + '\n' + "Question" + '\n';
          csvContent = csvContent + entry.content + '\n';
        }
        if (entry.role === 'assistant') {
          const result = entry.content as any[];
  
          if (!result || result.length === 0) return;
  
          
          const headers = Object.keys(result[0]);
  
          
          const rows = result.map((item: any) => headers.map(header => item[header]));
  
          
          let csvContents = headers.join(',') + '\n';
          rows.forEach((row: any[]) => {
            csvContents += row.join(',') + '\n';
          });
          csvContent = csvContent + 'Answer' + '\n';
          csvContent = csvContent + csvContents + '\n';
        }
      });
  
      this.saveFile(csvContent, 'conversation_data.csv');
  
    } catch (err) {
      console.log(err);  
    }
  }




  saveFile(data: string, filename: string): void {
    const blob = new Blob([data], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  }

  replaceTrainingInfo(arr1:any, arr2:any) {
    // Create a map of content to training_info from arr2 for quick lookup
    const contentToTrainingInfo :any= {};
    for (const item of arr2) {
        if (item.role === "user") {
            contentToTrainingInfo[item.content] = item.training_info;
        }
    }
    
    // Update arr1 with matching training_info
    for (const item of arr1) {
        if (item.role === "user" && contentToTrainingInfo[item.content]) {
            item.training_info = contentToTrainingInfo[item.content];
        }
    }
    
    return arr1;
}


  
}